/* eslint-disable react/no-danger */
import React, { useEffect, useState } from "react";
import SkeletonBox from "components/SkeletonBox";
import { useParams } from "react-router-dom";
import descriptionSvc from "services/descriptionSvc";
import CodeSnippet from "components/CodeSnippet";

const APIDocumentation = () => {
  const params = useParams();
  const [isLoading, setLoading] = useState(true);
  const [error, setError] = useState();
  const [desc, setDesc] = useState();

  useEffect(() => {
    const { childId } = params;
    getDescription(childId);
  }, [params]);

  const getDescription = async (titleId) => {
    try {
      setLoading(true);
      setError("");
      const description = await descriptionSvc.getByTitleId(titleId);
      setDesc(description?.data?.data);
      setLoading(false);
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  if (isLoading) {
    return (
      <div className="margin-inline-20">
        <SkeletonBox count={4} />
      </div>
    );
  }

  if (error) {
    return <div>{error}</div>;
  }

  return (
    <div className="d-flex flex-row">
      <div className="col-7 padding-layout">
        <div dangerouslySetInnerHTML={{ __html: desc.description }} />
      </div>
      <div className="col-sm">
        {!desc?.languageSupport ? (
          <p>&nbsp;</p>
        ) : (
            <CodeSnippet
              className="position-sticky sticky-with-header"
              listReqRes={desc.languageSupport}
            />
          )}
      </div>
    </div>
  );
};

export default APIDocumentation;
